import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { AuthResponse } from "@/api/types";
import { toast } from "@/components/ui/toast";
import { normalizePhone } from "@/lib/normalize-phone";
import { transitionSession } from "@/lib/session-transition";

interface RequestCodeInput {
  mobile_number: string;
}

interface RequestCodeResponse {
  dispatched: boolean;
  destination: string;
  challenge_id?: string;
  dev_code?: string;
}

interface VerifyCodeInput {
  mobile_number: string;
  code: string;
  challenge_id?: string;
}

export function useRequestPhoneCode() {
  return useMutation({
    mutationFn: (data: RequestCodeInput) =>
      api
        .post("auth/phone/request_code", {
          json: { ...data, mobile_number: normalizePhone(data.mobile_number) },
        })
        .json<RequestCodeResponse>(),
    onSuccess: (data) => {
      if (data.dev_code) {
        toast({ variant: "info", title: `Dev code: ${data.dev_code}` });
      }
    },
  });
}

export function useVerifyPhoneCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: VerifyCodeInput) =>
      api
        .post("auth/phone/verify", {
          json: { ...data, mobile_number: normalizePhone(data.mobile_number) },
        })
        .json<AuthResponse>(),
    onSuccess: (data, _variables, _result, context) => {
      transitionSession(queryClient, data.user, context);
    },
  });
}
